import PropTypes from 'prop-types';
import queryString from 'query-string';
import React, { useMemo } from 'react';

const withParamsGuard = (Component) => {
  const WrappedComponent = (props) => {
    const parameters = useMemo(() => (
      queryString.parse(props.location.search.substr(1))
    ), [props.location.search]);

    return (
      <Component
        {...props}
        parameters={parameters}
      />
    );
  };

  WrappedComponent.propTypes = {
    parameters: PropTypes.shape({
      client_id: PropTypes.string,
      country: PropTypes.string,
      redirect_uri: PropTypes.string,
      response_type: PropTypes.string,
      state: PropTypes.string
    }),
    location: PropTypes.shape({
      search: PropTypes.string
    })
  };

  return WrappedComponent;
};

export default withParamsGuard;
